import {Map} from 'immutable';

import {
  SET_ORGANIZATIONS
} from './actions';

const shared = (state = Map({ organizations: [] }), action) => {
    switch (action.type) {
      case SET_ORGANIZATIONS:
        return state.setIn(['organizations'], action.payload.organizations);
      default:
        return state;
    }
};

export default shared;


// WEBPACK FOOTER //
// ./src/shared/reducers.js